import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { useRelations } from '@hooks/useAgencyProvider'

import { AgencyProviderModel } from '@models/agencyProvider'
import { ProviderPriceListModel } from '@models/providerPriceList'

const PriceListItem = (props: { agencyProvider: AgencyProviderModel }) => {
  const { agencyProvider } = props

  const agencyProviderPayload = useRelations(agencyProvider)

  const {
    providerPriceList,
    provider,
    service,
  } = agencyProviderPayload

  // @ts-expect-error TS2339
  if (!providerPriceList.id) return null

  const {
    id,
    title,
  }: Partial<ProviderPriceListModel> = providerPriceList || {}

  return (
    <DashboardModuleListItem
      // @ts-expect-error TS2339
      secondaryText={`${provider?.title} | ${service?.title}`}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        # {id}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default PriceListItem
